import type { RouteRecordRaw } from 'vue-router';
import { Urls } from '@/config/Urls';
import { UserRoles } from '@/modules/admin/interfaces/UserRoles';

export const leaderboardRoutes: RouteRecordRaw[] = [
  {
    path: Urls.LEADERBOARD,
    name: 'leaderboard',
    component: () => import('./pages/LeaderboardPage.vue'),
    meta: {
      requiresAuth: true,
      roles: [UserRoles.ADMIN, UserRoles.GATEKEEPER, UserRoles.SUPERVISOR, UserRoles.JUDGE],
    },
  },
  {
    path: `${Urls.JUDGE_PROFILE}/:uuid`,
    name: 'judgeProfile',
    component: () => import('./pages/JudgeProfilePage.vue'),
    meta: { requiresAuth: true, requiresSupervisor: true },
  },
];
